export { default } from './ProfessorsSectionItem';
